// src/pages/LorePage.js
import React from "react";
import { ONI_FORMS } from "../data/demons";
import "./SimplePage.css";

export default function LorePage() {
  return (
    <div className="simple-page">
      <div className="section" style={{paddingTop:"8rem"}}>
        <div className="simple-header">
          <span className="section-eyebrow">伝説 · La Légende</span>
          <h1 className="section-title">Le Lore</h1>
          <div className="divider"/>
        </div>

        <div className="lore-body">
          <div className="lore-block">
            <h2>L'Origine</h2>
            <p>Il est dit que le premier coup de raquette frappé dans la <span>rage pure</span> ouvrit une porte. Pas une porte vers la victoire — une porte vers l'autre côté.</p>
            <p>De l'autre côté vivent les <span>Takkyu Oni</span> : démons nés de chaque mauvaise excuse, de chaque service illégal assumé, de chaque rouleau qui passe sur le filet en finale.</p>
            <p>Ils ne sont pas tes ennemis. Ils <span>sont toi</span>. Le côté que tu n'avoues jamais au vestiaire. Le petit cri que tu retiens quand tu rates le coup droit facile à 10-9.</p>
          </div>

          <div className="lore-quote-block">
            <p className="lore-jp">「卓球の鬼は怒りから生まれる。<br/>しかし、その怒りこそが力だ。<br/>自分の鬼を知る者だけが、<br/>真の卓球師になれる。」</p>
            <p className="lore-fr">"Le démon du ping naît de la colère. Mais cette colère est sa force. Seul celui qui connaît son démon peut devenir un vrai maître de la balle."</p>
            <cite>— AINO, Démon en Chef · 悪魔長</cite>
          </div>

          <div className="lore-block">
            <h2>Les Formes Oni</h2>
            <p>Douze archétypes. Douze manières d'être possédé par le ping. Chacun correspond à un style de jeu, un comportement, une obsession.</p>
            <div className="oni-lore-grid">
              {ONI_FORMS.map(oni => (
                <div key={oni.id} className="oni-lore-card">
                  <div className="oni-lore-emoji">{oni.emoji}</div>
                  <div>
                    <p className="oni-lore-jp">{oni.jp}</p>
                    <p className="oni-lore-name">{oni.name}</p>
                    <p className="oni-lore-desc">{oni.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lore-block">
            <h2>Les Stats Démoniaques</h2>
            <div className="stats-legend">
              <div className="stat-def"><span style={{color:"var(--blood)"}}>● COLÈRE</span> — L'intensité émotionnelle brute. Les screamer et rager scorent haut. Les défenseurs patients, moins.</div>
              <div className="stat-def"><span style={{color:"var(--ember)"}}>● DESTRUCTION</span> — L'envie pure de faire du dégât, à la table ou à l'extérieur. Les attaquants frénétiques règnent.</div>
              <div className="stat-def"><span style={{color:"var(--gold)"}}>● TCHO</span> — Le niveau de tchatche, d'excuses, de manipulation psychologique. L'excuse guy est champion.</div>
              <div className="stat-def"><span style={{color:"#7ecec4"}}>● MATOS</span> — L'obsession pour l'équipement. L'equipment junky et les picot users scorent haut.</div>
              <div className="stat-def"><span style={{color:"#b07fe8"}}>● VIOLENCE</span> — La force physique brute mise dans les frappes. Le ball breaker et le rager dominent.</div>
              <div className="stat-def"><span style={{color:"var(--paper2)"}}>● LAWFUL / CHAOS</span> — L'axe fondamental. Lawful = défenseur patient et régulier. Chaos = trick shots et picots longues.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
